var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.817,16.666H4.842A4.453,4.453,0,0,1,0,11.817V4.842A4.449,4.449,0,0,1,4.842,0h6.983a4.888,4.888,0,0,1,3.56,1.286,4.878,4.878,0,0,1,1.273,3.556v6.983A4.448,4.448,0,0,1,11.817,16.666ZM4.834,6.834a1,1,0,0,0-1,1v1a1,1,0,0,0,1,1h2v2a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1v-2h2a1,1,0,0,0,1-1v-1a1,1,0,0,0-1-1h-2v-2a1,1,0,0,0-1-1h-1a1,1,0,0,0-1,1v2Z",
    transform: "translate(1.667 1.667)",
    fill: "#8963f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20V20H0Z",
    transform: "translate(20 20) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHealth);
export default __webpack_public_path__ + "static/media/icon-health.6d3acf632400287c43726297880ac2bf.svg";
export { ForwardRef as ReactComponent };